import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@mui/material';

const ControlledCheckbox = ({ name, label }) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => <FormControlLabel control={<Checkbox {...field} checked={field.value || false} />} label={`${label}?`} />}
            // wrap
        />
    );
};

export default ControlledCheckbox;
